export default __webpack_public_path__ + "static/media/SAZEW.d81971e3.png";